(() => {
  'use strict';
  const initialize = () => {
    const header = document.querySelector('[data-hsb-header]');
    if (!header || header.dataset.hsbNavigationReady === 'true') return;
    const menu = header.querySelector('[data-hsb-menu]');
    const toggle = header.querySelector('[data-hsb-menu-toggle]');
    if (!menu || !toggle) return;
    header.dataset.hsbNavigationReady = 'true';
    const media = window.matchMedia('(max-width: 850px)');
    const section = header.closest('.shopify-section') || header;
    section.classList.add('hsb-header-section');
    const isOpen = () => toggle.getAttribute('aria-expanded') === 'true';
    const close = (returnFocus = false) => {
      menu.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Menu';
      document.body.classList.remove('menu-open');
      if (returnFocus && media.matches) toggle.focus();
    };
    toggle.addEventListener('click', () => {
      if (isOpen()) { close(); return; }
      menu.classList.add('open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.textContent = 'Fechar';
      document.body.classList.add('menu-open');
    });
    menu.addEventListener('click', event => {
      if (event.target.closest('a')) close();
    });
    document.addEventListener('keydown', event => {
      if (!isOpen() || !media.matches) return;
      if (event.key === 'Escape') { event.preventDefault(); close(true); }
    });
    document.addEventListener('click', event => {
      if (isOpen() && !header.contains(event.target)) close();
    });
    header.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (isOpen() && !header.contains(document.activeElement)) close();
      });
    });
    const viewportChange = () => { if (!media.matches) close(); };
    if (typeof media.addEventListener === 'function') media.addEventListener('change', viewportChange);
    else if (typeof media.addListener === 'function') media.addListener(viewportChange);
    const preview = header.querySelector('[data-hsb-preview-bar]');
    const shipping = header.querySelector('[data-hsb-shipping-bar]');
    const offset = () => {
      const height = (preview ? preview.offsetHeight : 0) + (shipping ? shipping.offsetHeight : 0);
      section.style.setProperty('--header-offset', `-${height}px`);
    };
    offset();
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(offset);
      if (preview) observer.observe(preview);
      if (shipping) observer.observe(shipping);
    } else window.addEventListener('resize', offset, {passive: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
